import { Link } from "react-router-dom";
import DetailAccentCard from "./DetailAccentCard";

/**
 * Management card for site admins who are not the content owner (or when inline edit is dashboard-only).
 */
export default function DetailAdminManagementPanel({
	ariaLabel = "مدیریت",
	editHref,
	editLabel = "ویرایش",
	dashboardHref,
	dashboardLabel = "پنل مدیریت",
	adminNote,
	children,
}) {
	return (
		<DetailAccentCard bodyClassName="p-4" ariaLabel={ariaLabel}>
			<p className="mb-3 font-Vazir-600 text-[13px] text-midGray">مدیریت</p>
			{adminNote && (
				<p className="mb-3 font-Vazir-400 text-[12px] leading-relaxed text-darkBlue/60">
					{adminNote}
				</p>
			)}
			<div className="flex flex-col gap-2">
				{editHref && (
					<Link
						to={editHref}
						className="rounded-[10px] bg-lightCta py-2.5 text-center font-Vazir-600 text-[14px] text-darkBlue no-underline transition hover:bg-[#E0EEF8]"
					>
						{editLabel}
					</Link>
				)}
				{dashboardHref && (
					<Link
						to={dashboardHref}
						className="rounded-[10px] border border-darkBlue/15 bg-white py-2.5 text-center font-Vazir-600 text-[14px] text-darkBlue no-underline transition hover:border-darkBlue/30"
					>
						{dashboardLabel}
					</Link>
				)}
				{children}
			</div>
		</DetailAccentCard>
	);
}
